import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';

// import NotFound from "./pages/notFound/NotFound";
import MainScreen from "./pages/account/mainscreen";
import Client from "./layout/client";
import LoginPage from "./pages/management/login/login";
import Dashboard from "./pages/management/dashboard";
import Members from "./pages/management/members/members";
import Users from "./pages/management/users/users";
import Guests from "./pages/management/guests/guests";
import Instructors from "./pages/management/instructors/instructors";
import Gallery from "./pages/management/galley/gallery";
import Plans from "./pages/management/plans/plans";
import Bookings from "./pages/management/bookings/bookings";
import Challenges from "./pages/management/challenges/challenges";
import Achievements from "./pages/management/achievements/achievements";
import Payments from "./pages/management/payments/payments";
import Subscriptions from "./pages/management/subscriptions/subscriptionoffers";
import NotFound from "./pages/notFound/NotFound";
import Forgotpassword from "./pages/management/login/forgotpassword";
import ResetPassword from "./pages/management/login/resetPassword";

const PrivateRoute = ({ children }) => {
    const auth = localStorage.getItem("gym_user");
    const isLoggedIn = auth && JSON.parse(auth).user_id;
    return isLoggedIn ? children : <Navigate to="/account/login" />;
};

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<Client />} />
                {/* Login Route */}
                <Route path="/auth/login" element={<LoginPage />} />
                <Route path="/auth/forgotpassword" element={<Forgotpassword />} />
                <Route path="/auth/resetpassword" element={<ResetPassword />} />
                <Route path="account/" element={<MainScreen />}>
                    {/* Protected Routes */}
                    <Route index element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    } />
                    <Route path="members" element={
                        <PrivateRoute>
                            <Members />
                        </PrivateRoute>
                    } />
                    <Route path="users" element={
                        <PrivateRoute>
                            <Users />
                        </PrivateRoute>
                    } />
                    <Route path="guests" element={
                        <PrivateRoute>
                            <Guests />
                        </PrivateRoute>
                    } />
                    <Route path="instructors" element={
                        <PrivateRoute>
                            <Instructors />
                        </PrivateRoute>
                    } />
                    <Route path="gallery" element={
                        <PrivateRoute>
                            <Gallery />
                        </PrivateRoute>
                    } />
                    <Route path="plans" element={
                        <PrivateRoute>
                            <Plans />
                        </PrivateRoute>
                    } />
                    <Route path="bookings" element={
                        <PrivateRoute>
                            <Bookings />
                        </PrivateRoute>
                    } />
                    <Route path="challenges" element={
                        <PrivateRoute>
                            <Challenges />
                        </PrivateRoute>
                    } />
                    <Route path="achievements" element={
                        <PrivateRoute>
                            <Achievements />
                        </PrivateRoute>
                    } />
                    <Route path="payments" element={
                        <PrivateRoute>
                            <Payments />
                        </PrivateRoute>
                    } />
                    <Route path="subscriptions" element={
                        <PrivateRoute>
                            <Subscriptions />
                        </PrivateRoute>
                    } />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>

            <Toaster
                position="top-right"
                reverseOrder={false}
                toastOptions={{
                    className: '',
                    duration: 5000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                }}
            />
        </BrowserRouter>
    );
};

export default App;
